import CustomSourceFlowText from "@/components/Shared/CustomSourceflowText";
import vectorTop from "@/assets/legal/vector-top-banner.png";
import vectorLeft from "@/assets/legal/vector-left.png";
import useLocale from "@/hooks/useLocale";

export default function LegalBanner() {
  const locale = useLocale();

  return (
    <div className="md:px-2 2xl:px-2 mx-auto w-full">
      <div className="bg-purple h-screen sm:h-[789px] relative flex items-end overflow-hidden max-h-[780px]">
        <img
          src={vectorTop ?? ""}
          alt="vector top"
          className="absolute top-0 right-[-127px]"
        />
        <img
          src={vectorLeft ?? ""}
          alt="vector left"
          className="absolute bottom-[126px] left-[-55px]"
        />
        <div className="container pb-10 relative">
          <p className="text-lg/[27px] font-semibold text-pink">
            <CustomSourceFlowText
              title="PRIVACY POLICY"
              path="dynamic1.privacy.header1"
              locale={locale}
            />
          </p>
          <h1 className="text-[40px]/[50px] md:text-6xl lg:text-[100px] max-w-[957px] mt-5">
            <CustomSourceFlowText
              title="Your privacy matters to us"
              path="dynamic1.privacy.header2"
              locale={locale}
            />
            <span className="text-pink">.</span>
          </h1>
          <h3 className="text-lg sm:text-xl md:text-2xl lg:text-[30px]/[42px] max-w-[807px] pt-6">
            <CustomSourceFlowText
              title="We’ve been helping clients achieve the results they need for over 20 years. In that time, we’ve."
              path="dynamic1.privacy.text1"
              locale={locale}
            />
          </h3>
        </div>
      </div>
    </div>
  );
}
